module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Date Calendar Settings</span></div>\r\n<div class=\"row prop-detail\">\r\n	<div class=\"row\">\r\n		<div class=\"col-md-12 prop-sublabel form-group-flex\">\r\n			<input type=\"radio\" name=\"dateValueType\" value=\"Now\" class=\"form-radio-group\"/>\r\n			<label class=\"form-group-label\">Now</label>\r\n		</div>\r\n	</div>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-4 prop-sublabel form-group-flex\">\r\n			<input type=\"radio\" name=\"dateValueType\" value=\"Specific\" class=\"form-radio-group\" />\r\n			<label class=\"form-group-label\">Specific</label>\r\n		</div>\r\n		<div class=\"col-md-8 col-xs-12 nopadding\" style=\"display:flex\">\r\n			<input type=\"text\" name=\"dateValueSpecific\" min=\"")
    ; __append(escapeFn(minYear))
    ; __append("-01-01\" max=\"")
    ; __append(escapeFn(maxYear))
    ; __append("-12-31\" id=\"dateValueSpecific\"   value=\"")
    ; __append(escapeFn(dateValue))
    ; __append("\" style=\"width: 56%\"/>\r\n		</div>\r\n	</div>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-4 prop-sublabel\">\r\n			Years:\r\n		</div>\r\n		<div class=\"col-md-4 subsection nopadding\">\r\n			<div class=\"label-45\" style=\"margin-right:4px;\">\r\n				<input type=\"text\" name=\"minYear\" id=\"yearsFrom\" value=\"")
    ; __append(escapeFn(minYear))
    ; __append("\" style=\"width:50px;padding:11px;\" />\r\n			</div>\r\n			<label class=\"prop-sublabel\" style=\"padding: 0 6px;\">to</label>\r\n			<div class=\"nopadding label-45\">\r\n				<input type=\"text\" name=\"maxYear\" id=\"yearsTo\" value=\"")
    ; __append(escapeFn(maxYear))
    ; __append("\" style=\"width:50px;padding:11px;\"  />\r\n			</div>\r\n		</div>\r\n		\r\n	</div>\r\n</div>")
  }
  return __output;

}